export default "__VITE_ASSET__b94e67f6__"